<!-- 实例节点 -->
<template>
    <div v-if="componentsData.type == 16">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <div
                class="fw-bold flex-c"
                v-if="componentsData.content.style_value == 1"
                :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                `"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content">
                    {{ componentsData.content.title }}
                </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div
                v-else
                class="fw-bold"
                :style="`text-align: ${componentsData.content.position};border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                `"
            >
                {{ componentsData.content.title }}
            </div>
            <div
                class="pt-12"
                :style="` font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color}; `"
            >
                <div>
                    <div class="dis-flex">
                        <div
                            class="flex-c flex-column ml-6 mt-6"
                            v-if="componentsData.content.mode_id == 1"
                        >
                            <div
                                class="w10"
                                :style="`border: 2px solid ${componentsData.content.circle_color};`"
                            ></div>
                            <div
                                class="txt"
                                :style="`background: ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6 mt-6"
                            v-if="componentsData.content.mode_id == 2"
                        >
                            <div
                                class="flex-1"
                                :style="`border-left: 2px dashed ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6 mt-6"
                            v-if="componentsData.content.mode_id == 3"
                        >
                            <div
                                class="txt"
                                :style="`background: ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6 mt-6"
                            v-if="componentsData.content.mode_id == 4"
                        >
                            <img
                                :src="componentsData.content.mode_img.picview"
                                alt=""
                                class="mode-img"
                            />
                            <div
                                class="txt"
                                :style="`background: ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6 mt-6"
                            v-if="componentsData.content.mode_id == 5"
                        >
                            <img
                                :src="componentsData.content.mode_img.picview"
                                alt=""
                                class="mode-img"
                            />
                            <div
                                class="flex-1"
                                :style="`border-left: 2px dashed ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div class="ta-l ml12 mb24">
                            <div
                                :style="`font-size: ${componentsData.content.mould_size}px; color: ${componentsData.content.mould_color};font-weight: bold;`"
                            >
                                模板名称
                            </div>
                            <div class="ml12">
                                <div class="flex-sb mt-6">
                                    <div>节点名称</div>
                                    <div class="time-div">2024.10.18 安徽</div>
                                </div>
                                <div
                                    class="txt-content"
                                    :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                                >
                                    节点内容节点内容节点内容节点内容节容节点内容节点内容节点内容节点内容
                                </div>
                                <div class="content-div"></div>
                            </div>
                        </div>
                    </div>
                    <div class="dis-flex">
                        <div
                            class="ml-6"
                            v-if="componentsData.content.mode_id == 1"
                        >
                            <div
                                class="w10"
                                :style="`border: 2px solid ${componentsData.content.circle_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6"
                            v-if="componentsData.content.mode_id == 2"
                        >
                            <div
                                class="flex-1"
                                :style="`border-left: 2px dashed ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="flex-c flex-column ml-6"
                            v-if="componentsData.content.mode_id == 3"
                        >
                            <div
                                class="txt"
                                :style="`background: ${componentsData.content.line_color};`"
                            ></div>
                        </div>
                        <div
                            class="ml-6"
                            v-if="componentsData.content.mode_id == 4"
                        >
                            <img
                                :src="componentsData.content.mode_img.picview"
                                alt=""
                                class="mode-img"
                            />
                        </div>
                        <div
                            class="ml-6"
                            v-if="componentsData.content.mode_id == 5"
                        >
                            <img
                                :src="componentsData.content.mode_img.picview"
                                alt=""
                                class="mode-img"
                            />
                        </div>
                        <div class="ta-l ml12" style="margin-top: -6px">
                            <div
                                :style="`font-size: ${componentsData.content.mould_size}px; color: ${componentsData.content.mould_color};font-weight: bold;`"
                            >
                                模板名称
                            </div>
                            <div class="ml12">
                                <div class="flex-sb mt-6">
                                    <div>节点名称</div>
                                    <div class="time-div">2024.10.18 安徽</div>
                                </div>
                                <div
                                    class="txt-content"
                                    :style="`font-size: ${componentsData.content.txt_size}px; color: ${componentsData.content.txt_color};`"
                                >
                                    节点内容节点内容节点内容节点内容节容节点内容节点内容节点内容节点内容
                                </div>
                                <div class="content-div"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    padding-bottom: 6px;
}
.dis-flex {
    display: flex;
}
.mb-6 {
    margin: 0 0 6px 0;
}
.mr-6 {
    margin: 0 6px 0 0;
}
.ml-6 {
    margin: 0 0 0 6px;
}
.w10 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
.txt {
    width: 2px;
    border-radius: 1px;
    flex: 1;
}
.flex-1 {
    flex: 1;
}
.content-div {
    width: 100%;
    height: 148.8px;
    background: #ccc;
}
.ta-r {
    text-align: right;
}
.ta-l {
    text-align: left;
}
.flex-column {
    flex-direction: column !important;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.txt-content {
    margin: 6px 0;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.pt-12 {
    padding-top: 12px;
}
.time-div {
    color: #ccc;
    font-size: 12px;
}
.mt-6 {
    margin-top: 6px;
}
.mode-img {
    width: 20px;
    height: 20px;
}
</style>